import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { Dispatch } from 'redux';
import type { AppState } from '../../state/createStore';

// Use throughout the app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<Dispatch>();
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
